import { createSelector } from "reselect";

export const getAllAvailabilityTypes = (state) => state.availability_types;
export const getAllAvailabilityTypesAsArray = createSelector(getAllAvailabilityTypes, (types) =>
  Object.values(types).sort((a, b) => {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  })
);

export const getAvailabilityTypeById = createSelector(
  getAllAvailabilityTypes,
  (state, id) => id,
  (types, id) => types[id]
);
